// // MeetingAttendancePDF.js
// import React from 'react';
// import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';

// const styles = StyleSheet.create({
//   page: { padding: 30 },
//   section: { marginBottom: 10 },
//   heading: { fontSize: 18, marginBottom: 10 },
//   tableHeader: { fontWeight: 'bold', marginBottom: 5 },
//   tableRow: { flexDirection: 'row', marginBottom: 2 },
//   cell: { width: '25%', fontSize: 10 },
// });

// const MeetingAttendancePDF = ({ selectedDate, selectedVenue, selectedMeetingDetails, invitationsget, getUserNameById }) => {
//   const filteredInvitations = invitationsget.filter(
//     (invite) => invite.meeting_id === selectedMeetingDetails[0]?.meeting_id
//   );

//   return (
//     <Document>
//       <Page style={styles.page}>
//         <View style={styles.section}>
//           <Text style={styles.heading}>Meeting Attendance Report</Text>
//           <Text>Date: {new Date(selectedDate).toLocaleDateString()}</Text>
//           <Text>Venue: {selectedVenue}</Text>
//         </View>

//         <View style={styles.section}>
//           <Text style={styles.tableHeader}>Meeting Attendees</Text>
//           {selectedMeetingDetails.map((meeting, index) => {
//             const isMeetingExpired = new Date(meeting.date) < new Date();
//             let responseText = meeting.response === 'yes' ? 'Attended' : 'Not Attended';
//             if (isMeetingExpired) responseText = meeting.response === 'yes' ? 'Present' : 'Absent';

//             return (
//               <View style={styles.tableRow} key={index}>
//                 <Text style={styles.cell}>{meeting.user_id}</Text>
//                 <Text style={styles.cell}>{meeting.user_email}</Text>
//                 <Text style={styles.cell}>{responseText}</Text>
//               </View>
//             );
//           })}
//         </View>

//         <View style={styles.section}>
//           <Text style={styles.tableHeader}>Visitor Invitations</Text>
//           {filteredInvitations.map((invite, index) => (
//             <View style={styles.tableRow} key={index}>
//               <Text style={styles.cell}>{getUserNameById(invite.userId)}</Text>
//               <Text style={styles.cell}>{invite.visitor_name}</Text>
//               <Text style={styles.cell}>{invite.visitor_email}</Text>
//               <Text style={styles.cell}>
//                 {invite.response
//                   ? invite.response === 'yes'
//                     ? 'Attending'
//                     : 'Not Attending'
//                   : 'Pending'}
//               </Text>
//             </View>
//           ))}
//         </View>
//       </Page>
//     </Document>
//   );
// };

// export default MeetingAttendancePDF;


// MeetingAttendancePDF.js


import React from 'react';
import {
    Document,
    Page,
    Text,
    View,
    StyleSheet,
} from '@react-pdf/renderer';

// 🔧 PDF styles
const styles = StyleSheet.create({
    page: {
        padding: 30,
        fontSize: 10,
    },
    title: {
        fontSize: 18,
        marginBottom: 10,
        textAlign: 'center',
    },
    sectionTitle: {
        fontSize: 14,
        marginBottom: 8,
        marginTop: 20,
        textDecoration: 'underline',
    },
    infoText: {
        marginBottom: 10,
    },
    table: {
        display: 'table',
        width: 'auto',
        borderStyle: 'solid',
        borderWidth: 1,
        borderRightWidth: 0,
        borderBottomWidth: 0,
        marginTop: 10,
    },
    tableRow: {
        flexDirection: 'row',
    },
    tableColHeader: {
        backgroundColor: '#f0f0f0',
        borderStyle: 'solid',
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        width: '25%',
        padding: 4,
        fontWeight: 'bold',
    },
    tableCol: {
        borderStyle: 'solid',
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        width: '25%',
        padding: 4,
    },

    presentText: {
        color: 'green',
    },
    absentText: {
        color: 'red',
    },
    pendingText: {
        color: 'orange', // use orange or darker yellow for readability
    },
});

const MeetingAttendancePDF = ({
    selectedDate,
    selectedVenue,
    selectedMeetingDetails,
    invitationsget,
    getUserNameById,
}) => {
    const formattedDate = new Date(selectedDate).toLocaleDateString();
    const filteredInvitations = invitationsget.filter(
        (invite) => invite.meeting_id === selectedMeetingDetails[0]?.meeting_id
    );

    return (
        <Document>
            {/* Page 1: Attendance Report */}
            <Page style={styles.page}>
                <Text style={styles.title}>Meeting Attendance Report</Text>
                <Text style={styles.infoText}>Date: {formattedDate}</Text>
                <Text style={styles.infoText}>Venue: {selectedVenue}</Text>

                <Text style={styles.sectionTitle}>Attendee List</Text>

                <View style={styles.table}>
                    <View style={styles.tableRow}>
                        {/* <Text style={styles.tableColHeader}>UserID</Text> */}
                        <Text style={styles.tableColHeader}>User Email</Text>
                        <Text style={styles.tableColHeader}>Response</Text>
                        <Text style={styles.tableColHeader}>Status</Text>
                    </View>

                    {selectedMeetingDetails.map((meeting, index) => {
                        const isMeetingExpired = new Date(meeting.date) < new Date();
                        let responseText = meeting.response === 'yes' ? 'Attended' : 'Not Attended';
                        let status = isMeetingExpired
                            ? meeting.response === 'yes'
                                ? 'Present'
                                : 'Absent'
                            : '-';

                        return (
                            <View style={styles.tableRow} key={index}>
                                {/* <Text style={styles.tableCol}>{meeting.user_id}</Text> */}
                                <Text style={styles.tableCol}>{meeting.user_email}</Text>
                                <Text style={styles.tableCol}>{responseText}</Text>
                                {/* <Text style={styles.tableCol}>{status}</Text> */}
                                <Text
                                    style={[
                                        styles.tableCol,
                                        status === 'Present' ? styles.presentText : status === 'Absent' ? styles.absentText : null,
                                    ]}
                                >
                                    {status}
                                </Text>
                            </View>
                        );
                    })}
                </View>
            </Page>

            {/* Page 2: Visitor Invitations */}
            <Page style={styles.page}>
                <Text style={styles.title}>Visitor Invitations</Text>
                <Text style={styles.infoText}>Date: {formattedDate}</Text>
                <Text style={styles.infoText}>Venue: {selectedVenue}</Text>

                <View style={styles.table}>
                    <View style={styles.tableRow}>
                        <Text style={styles.tableColHeader}>Sender</Text>
                        <Text style={styles.tableColHeader}>Visitor Name</Text>
                        <Text style={styles.tableColHeader}>Email</Text>
                        <Text style={styles.tableColHeader}>Response</Text>
                    </View>

                    {filteredInvitations.map((invite, index) => (
                        <View style={styles.tableRow} key={index}>
                            <Text style={styles.tableCol}>{getUserNameById(invite.userId)}</Text>
                            <Text style={styles.tableCol}>{invite.visitor_name}</Text>
                            <Text style={styles.tableCol}>{invite.visitor_email}</Text>
                            {/* <Text style={styles.tableCol}>
                {invite.response
                  ? invite.response === 'yes'
                    ? 'Attending'
                    : 'Not Attending'
                  : 'Pending'}
              </Text> */}
                            {/* <Text
  style={[
    styles.tableCol,
    invite.response === 'yes'
      ? styles.presentText  
      : invite.response === 'no'||'NULL'
      ? styles.absentText
        : invite.response === 'NULL'
        ? styles.pendingText
      : null,
  ]}
>
  {invite.response
    ? invite.response === 'yes'
      ? 'Attending'
      : 'Not Attending'
    : 'Pending'}
</Text> */}
                            <Text
                                style={[
                                    styles.tableCol,
                                    invite.response === 'yes'
                                        ? styles.presentText
                                        : invite.response === 'no'
                                            ? styles.absentText
                                            : invite.response === 'NULL'
                                                ? styles.pendingText
                                                : null,
                                ]}
                            >
                                {invite.response === 'yes'
                                    ? 'Attending'
                                    : invite.response === 'no'
                                        ? 'Not Attending'
                                        : 'Pending'}
                            </Text>


                        </View>
                    ))}
                </View>
            </Page>
        </Document>
    );
};

export default MeetingAttendancePDF;
